import { KeycloakManagerRouting } from '@aipb/gulliver/keycloak-manager/routing';
import { PaginatorI18n } from '@aipb/gulliver/translation';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Routes } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { EntryComponent } from './entry/entry.component';
import { KeycloakManagerInitGuard } from './keycloak-manager.init-guard';

export const KeycloakManagerRoutes: Routes = [
  {
    path: '',
    redirectTo: 'default',
    pathMatch: 'prefix'
  },
  {
    path: KeycloakManagerRouting.configPath,
    component: EntryComponent,
    providers: [
      KeycloakManagerInitGuard,
      {
        provide: MatPaginatorIntl,
        useFactory: (transloco: TranslocoService): MatPaginatorIntl => {
          return new PaginatorI18n(transloco);
        },
        deps: [TranslocoService]
      }
    ],
    canActivate: [KeycloakManagerInitGuard],
    children: [
      {
        path: '',
        redirectTo: KeycloakManagerRouting.dashboardPath,
        pathMatch: 'full'
      },
      {
        path: KeycloakManagerRouting.dashboardPath,
        loadChildren: () => import('@aipb/gulliver/keycloak-manager/feature-dashboard').then((m) => m.DashboardRoutes)
      },
      {
        path: KeycloakManagerRouting.userPath,
        loadChildren: () => import('@aipb/gulliver/keycloak-manager/feature-user').then((m) => m.UserRoutes)
      }
    ]
  }
];
